import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useSEO } from "../components/seo";
import { seoConfig } from "../seo-config";
import { Path } from "../constants/paths";

export const useSEOByRoute = () => {
  const location = useLocation();
  const { updateSEO } = useSEO();

  useEffect(() => {
    // First check for exact path matches
    const exactPath = Object.keys(seoConfig).find(
      (path) => path === location.pathname
    );

    if (exactPath) {
      // Use type assertion to tell TypeScript this is a valid key
      updateSEO(seoConfig[exactPath as keyof typeof seoConfig]);
      return;
    }

    // Check for dynamic routes
    if (matchPath(location.pathname, { path: Path.IDO, exact: true })) {
      // For IDO detail pages
      updateSEO(seoConfig["ido-detail"]);
      return;
    }

    if (
      matchPath(location.pathname, {
        path: Path.REF_STATISTICSBYID,
        exact: true,
      })
    ) {
      // For referral statistics by ID
      updateSEO(seoConfig[Path.REF_STATISTICS]);
      return;
    }

    // Default to main page if no match found
    updateSEO(seoConfig[Path.APP_MAIN]);
  }, [location.pathname, updateSEO]);
};

export default useSEOByRoute;
